import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useImBusStore = defineStore('imBus', () => {
  const timjs = ref(undefined)
  const imLinkShow = ref(false)
  const imiframeApi = ref(undefined)
  const logined = ref(false)
  const imRoom = ref({
    imLinkName: undefined,
    imLinkHead: undefined,
    imLinkAccount: undefined,
    imLinkScene: undefined,
    RoomId: undefined,
    userId: undefined,
    inviteID: undefined,
    mediaType: undefined
  })

  function setTimjs(val) {
    timjs.value = val
  }

  function setImLinkShowState(obj) {
    imRoom.value = {
      imLinkName: obj.imLinkName,
      imLinkHead: obj.imLinkHead,
      imLinkAccount: obj.imLinkAccount,
      imLinkScene: obj.imLinkScene,
      RoomId: obj.RoomId,
      userId: obj.userId,
      inviteID: obj.inviteID,
      mediaType: obj.mediaType
    }
    imLinkShow.value = obj.imLinkShow
  }

  function setImiframeApi(val) {
    imiframeApi.value = val
  }

  function setLogined() {
    logined.value = true
  }

  return {
    timjs,
    imLinkShow,
    imiframeApi,
    logined,
    imRoom,
    setTimjs,
    setImLinkShowState,
    setImiframeApi,
    setLogined
  }
})
